var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 1.75H5.25C4.2835 1.75 3.5 2.5335 3.5 3.5V17.5C3.5 18.4665 4.2835 19.25 5.25 19.25H15.75C16.7165 19.25 17.5 18.4665 17.5 17.5V3.5C17.5 2.5335 16.7165 1.75 15.75 1.75Z",
    fill: "#094A73"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 11.375C13.125 11.6071 13.0328 11.8296 12.8687 11.9937C12.7046 12.1578 12.4821 12.25 12.25 12.25H11.375V13.125C11.375 13.3571 11.2828 13.5796 11.1187 13.7437C10.9546 13.9078 10.7321 14 10.5 14C10.2679 14 10.0454 13.9078 9.88128 13.7437C9.71719 13.5796 9.625 13.3571 9.625 13.125V12.25H8.75C8.51794 12.25 8.29538 12.1578 8.13128 11.9937C7.96719 11.8296 7.875 11.6071 7.875 11.375C7.875 11.1429 7.96719 10.9204 8.13128 10.7563C8.29538 10.5922 8.51794 10.5 8.75 10.5H9.625V9.625C9.625 9.39294 9.71719 9.17038 9.88128 9.00628C10.0454 8.84219 10.2679 8.75 10.5 8.75C10.7321 8.75 10.9546 8.84219 11.1187 9.00628C11.2828 9.17038 11.375 9.39294 11.375 9.625V10.5H12.25C12.4821 10.5 12.7046 10.5922 12.8687 10.7563C13.0328 10.9204 13.125 11.1429 13.125 11.375ZM14 1.75H7V2.625C7 3.08913 7.18437 3.53425 7.51256 3.86244C7.84075 4.19063 8.28587 4.375 8.75 4.375H12.25C12.7141 4.375 13.1592 4.19063 13.4874 3.86244C13.8156 3.53425 14 3.08913 14 2.625V1.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedical);
export default __webpack_public_path__ + "static/media/medical.ffbc05e3a7196a00d081c20d73bc9bbc.svg";
export { ForwardRef as ReactComponent };